export const ErrorType = {
  TOKEN_ERROR: 'token_error',
  NETWORK_ERROR: 'network_error',
  API_ERROR: 'api_error',
};

export default {
  ErrorType,
};
